// src/layouts/MerchantRegistrationLayout.js
import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import '../static/css/MerchantRegistrationLayout.css';
import PropTypes from 'prop-types';
import { MerchantLayout } from './Style';
import { Main } from '../container/styled';
import logo from '../static/img/icon/tripago-logo.png';
import AuthInfo from '../components/utilities/auth-info/info';

/** Path segments that require internal scrolling only (e.g. PDF viewer); layout will lock and avoid double scrollbars */
const INTERNAL_SCROLL_LOCK_PATHS = ['contract_signed'];

function MerchantRegistrationLayout(WraperContent) {
  function LayoutWrapper() {
    const isLoggedIn = useSelector((state) => state?.auth?.login);
    const location = useLocation();
    const pathSegments = location.pathname.replace(/^\//, '').split('/').filter(Boolean);
    const isPackageSourceRoute = pathSegments.length === 3 && pathSegments[0] === 'onboarding';
    const useInternalScrollLock = INTERNAL_SCROLL_LOCK_PATHS.some((segment) => location.pathname.includes(segment));
    const contentContainerClass = `content-container${useInternalScrollLock ? ' internal-scroll-lock' : ''}`;

    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <MerchantLayout className="merchant-registration-layout" isLoggedIn={isLoggedIn}>
          <div className="logo-container">
            <div className="logo-container-inner">
              <img src={logo} alt="logo" />
            </div>
          </div>

          <div className={contentContainerClass}>
            {isLoggedIn && !isPackageSourceRoute && (
              <div className="merchant-registration-toolbar merchant-registration-toolbar-flex">
                <AuthInfo />
              </div>
            )}
            <Main
              className="merchant-registration-main merchant-registration-main-content"
              minHeight={0}
              style={{ padding: '0px' }}
            >
              <WraperContent />
            </Main>
          </div>
        </MerchantLayout>
      </Suspense>
    );
  }

  return LayoutWrapper;
}

MerchantRegistrationLayout.propTypes = {
  WraperContent: PropTypes.elementType.isRequired,
};

export default MerchantRegistrationLayout;
